type OverlayScopeEntry = {
  id: string;
  element: HTMLElement;
  lastActiveAt: number;
};

const overlayScopes = new Map<string, OverlayScopeEntry>();

const getMountedScopes = () =>
  Array.from(overlayScopes.values()).filter(
    ({ element }) => element.isConnected,
  );

const getMostRelevantScope = () => {
  const mountedScopes = getMountedScopes();

  if (!mountedScopes.length) {
    return null;
  }

  mountedScopes.sort((left, right) => right.lastActiveAt - left.lastActiveAt);
  return mountedScopes[0]?.element ?? null;
};

export const registerOverlayScope = (id: string, element: HTMLElement) => {
  overlayScopes.set(id, {
    id,
    element,
    lastActiveAt: 0,
  });
};

export const unregisterOverlayScope = (id: string) => {
  overlayScopes.delete(id);
};

export const markOverlayScopeActive = (id: string) => {
  const scope = overlayScopes.get(id);
  if (!scope || !scope.element.isConnected) {
    return;
  }

  scope.lastActiveAt = Date.now();
};

export const getActiveOverlayContainer = () => getMostRelevantScope();
